import useFWUInfoLoaded from './useFWUInfoLoaded';
import useFwuTargets from './useFwuTargets';

const useAvailableFwu = ({checkIfHolderConnected} = {}) => {
    const iotTargets = useFwuTargets({checkIfHolderConnected});
    const {
        device_engine: deviceEngineFwu,
        device: deviceFwu,
        ble_stack: bleStackFwu,
        holder_engine: holderEngineFwu,
        holder: holderFwu,
        isAnyFwuAvailable,
        bleFwuCount,
        usbFwuCount,
    } = useFWUInfoLoaded({
        iotTargets,
    });

    // Here you can change the firmware installation order
    const availableFwuTargets = [deviceFwu, bleStackFwu, deviceEngineFwu, holderFwu, holderEngineFwu].filter(
        (fwu) => fwu?.isAvailable
    );

    return {
        deviceFwu,
        deviceEngineFwu,
        bleStackFwu,
        holderEngineFwu,
        holderFwu,
        availableFwuTargets,
        isAnyFwuAvailable,
        bleFwuCount,
        usbFwuCount,
    };
};

export default useAvailableFwu;
